import { IsNotEmpty, IsString } from 'class-validator';

/**
 * DTO for subdivision input when creating/updating countries
 * This excludes countryId since it's provided by the parent country
 */
export class CountrySubdivisionInputDto {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  code: string;
}
